import React from 'react'

import ROUTES from '../../constants/routes'
import { colors } from '../../constants/style'
import InfoBanner from '../banners/info-banner/InfoBanner'

function WantToKnowMore({ isUSRegion }) {
  return (
    <InfoBanner
      shadowed
      backgroundColor={colors.sky400}
      bannerTitle="Want to know more about the app?"
      bannerSubHeading="We're here to help."
      buttonText="Visit FAQs"
      linkButtonPath={isUSRegion ? ROUTES.US_FAQ : ROUTES.FAQ}
    />
  )
}

export default WantToKnowMore
